var kr = Object.defineProperty, Ar = Object.defineProperties;
var Pr = Object.getOwnPropertyDescriptors;
var Li = Object.getOwnPropertySymbols;
var Sr = Object.prototype.hasOwnProperty, Dr = Object.prototype.propertyIsEnumerable;
var vi = (t, i, a) => i in t ? kr(t, i, { enumerable: !0, configurable: !0, writable: !0, value: a }) : t[i] = a, r = (t, i) => {
  for (var a in i || (i = {}))
    Sr.call(i, a) && vi(t, a, i[a]);
  if (Li)
    for (var a of Li(i))
      Dr.call(i, a) && vi(t, a, i[a]);
  return t;
}, s = (t, i) => Ar(t, Pr(i));
import { LAYOUT_NODE_SHARED_CONTENT as Ui, CONTENT_NODE_NAVIGATION as Ri, CONTENT_NODE_LIST as Fi, CONTENT_NODE_BUTTON as Hi, CONTENT_NODE_FORM as Mi, CONTENT_NODE_QUOTE as Bi, CONTENT_NODE_TABLE as L, CONTENT_NODE_CARD as zi, CONTENT_NODE_SEPARATOR as Wi, CONTENT_NODE_SPACER as $i, CONTENT_NODE_PANEL as Gi, CONTENT_NODE_ACCORDION as qi, CONTENT_NODE_VIDEO as Yi, CONTENT_NODE_CODE as Vi, CONTENT_NODE_SLIDER as Qi, CONTENT_NODE_GALLERY as ji, CONTENT_NODE_IMAGE as O, CONTENT_NODE_TEXT as v, CONTENT_NODE_HEADING as x, LAYOUT_NODE_FULL_WIDTH_COLUMN as Xi, LAYOUT_NODE_RIGHT_SIDEBAR as Ki, LAYOUT_NODE_LEFT_SIDEBAR as Ji, LAYOUT_NODE_QUADRUPLE_COLUMN as Zi, LAYOUT_NODE_TRIPLE_COLUMN as di, LAYOUT_NODE_DOUBLE_COLUMN as tr, LAYOUT_NODE_SINGLE_COLUMN as ir, BASE_COLUMN as k, getBaseLayoutNode as A, getBaseContentNode as xi } from "@apptegy/page-builder";
const rr = "ts-one-column", er = "ts-two-column", sr = "ts-three-column", ar = "ts-four-column", U = "ts-full-width", cr = "ts-left-sidebar", or = "ts-right-sidebar", E = "pb-shared-content-block", pr = "ts-heading", nr = "ts-text", lr = "ts-video", gr = "ts-embed", ur = "ts-slider", mr = "ts-spacer", fr = "ts-image", _r = "ts-gallery", hr = "ts-divider", Tr = "ts-accordion", Lr = "ts-table", Cr = "ts-table-v2", Nr = "ts-button", br = "ts-card", yr = "ts-quote", Ir = "ts-form", Or = "ts-list", Er = "ts-navigation", Br = (t, i) => {
  var n;
  const a = i || {};
  return [
    {
      id: t.id,
      name: t.name,
      component: t.type,
      properties: wr(t),
      config: (n = t.nodes) == null ? void 0 : n.map((g) => [P(g, a)])
    }
  ];
}, P = (t, i) => {
  var a, n, g, C, m, f, _, o, h;
  switch (t.type) {
    case ir:
      return s(r({}, y(t, i)), {
        name: "One Column",
        component: rr
      });
    case tr:
      return s(r({}, y(t, i)), {
        name: "2 Columns",
        component: er
      });
    case di:
      return s(r({}, y(t, i)), {
        name: "3 Columns",
        component: sr
      });
    case Zi:
      return s(r({}, y(t, i)), {
        name: "4 Columns",
        component: ar
      });
    case Ji:
      return s(r({}, y(t, i)), {
        name: "Left Sidebar",
        component: cr
      });
    case Ki:
      return s(r({}, y(t, i)), {
        name: "Right Sidebar",
        component: or
      });
    case Xi:
      return s(r({}, y(t, i)), {
        name: "Full Width",
        component: U
      });
    case x:
      return {
        id: t.id,
        name: "Headline",
        component: pr,
        config: {
          blockId: t.id,
          content: t.content.html
        },
        properties: T(t),
        hasForm: !1
      };
    case v:
      return {
        id: t.id,
        name: "Text",
        component: nr,
        config: {
          blockId: t.id,
          content: t.content.html
        },
        properties: T(t),
        hasForm: !1
      };
    case O: {
      const p = {
        image: {
          // CONTENT
          url: (t == null ? void 0 : t.assetUrl) || ((a = t == null ? void 0 : t.content) == null ? void 0 : a.assetUrl) || ((n = i[t.content.assetId]) == null ? void 0 : n.url) || "",
          asset_id: t.content.assetId,
          alt_text: t.content.altText,
          caption: t.content.caption,
          link_url: t.content.link,
          // PROPERTIES
          set_ratio: t.properties.columnPercentage / 100,
          is_resized: t.properties.isResized,
          action_on_click: t.properties.actionOnClick,
          open_link_in_new_tab: t.properties.newTab,
          image_alignment: t.properties.imageAlignment,
          caption_alignment: t.properties.captionAlignment,
          show_caption: !!t.properties.showCaption,
          display: t.properties.resizeMode,
          cropped_width: t.properties.naturalWidth,
          cropped_height: t.properties.naturalHeight,
          preferred_width: t.properties.preferredWidth,
          preferred_height: t.properties.preferredHeight,
          decorative_image: t.properties.isDecorative,
          backgroundPosition: t.properties.backgroundPosition || "center",
          tilePercentage: t.properties.tilePercentage || 100
        }
      };
      return {
        id: t.id,
        name: "Image",
        component: fr,
        config: p,
        properties: T(t),
        hasForm: !0
      };
    }
    case ji: {
      const p = {
        blockId: t.id,
        gallery: {
          images: t.content.images.map((e) => {
            var l, b;
            return {
              url: (e == null ? void 0 : e.assetUrl) || ((l = e == null ? void 0 : e.content) == null ? void 0 : l.assetUrl) || ((b = i[e.content.assetId]) == null ? void 0 : b.url) || "",
              // URL is not included in the new version
              sizes: {},
              // Sizes are not included in the new version
              alt_text: e.content.altText,
              asset_id: e.content.assetId,
              cropped_width: e.properties.naturalWidth,
              cropped_height: e.properties.naturalHeight,
              decorative_image: e.properties.isDecorative,
              caption: e.content.caption,
              focalPointPosition: e.properties.focalPointPosition
            };
          }),
          columns: t.properties.columnsCount,
          hasLightbox: t.properties.isLightbox,
          showCaptions: t.properties.showCaptions,
          captionsAlignment: t.properties.captionsAlignment
        }
      };
      return {
        id: t.id,
        name: "Gallery",
        config: p,
        properties: T(t),
        hasForm: !0,
        component: _r
      };
    }
    case Qi: {
      const p = {
        blockId: t.id,
        slider: {
          images: t.content.images.map((e) => {
            var l, b;
            return {
              url: (e == null ? void 0 : e.assetUrl) || ((l = e == null ? void 0 : e.content) == null ? void 0 : l.assetUrl) || ((b = i[e.content.assetId]) == null ? void 0 : b.url) || "",
              // URL is not included in the new version
              sizes: {},
              // Sizes are not included in the new version
              alt_text: e.content.altText,
              asset_id: e.content.assetId,
              caption: e.content.caption,
              link_url: e.content.link,
              action_on_click: e.properties.actionOnClick,
              open_link_in_new_tab: e.properties.newTab,
              decorative_image: e.properties.isDecorative,
              focalPointPosition: e.properties.focalPointPosition,
              cropped_height: e.properties.naturalHeight,
              // NEW
              cropped_width: e.properties.naturalWidth
              // NEW
            };
          }),
          has_dots: t.properties.showDots,
          dot_position: t.properties.dotsPosition,
          has_arrows: t.properties.showArrows,
          arrow_position: t.properties.arrowsPosition,
          is_autoplay: t.properties.isAutoplay,
          transition: t.properties.transitionSpeed
        }
      };
      return {
        id: t.id,
        name: "Slider",
        config: p,
        properties: T(t),
        hasForm: !0,
        component: ur
      };
    }
    case Vi:
      return {
        id: t.id,
        name: "Code",
        component: gr,
        config: {
          blockId: t.id,
          embed: t.content.html,
          hasScriptTag: t.properties.hasScriptTag
        },
        properties: T(t),
        hasForm: !1
      };
    case Yi:
      return {
        id: t.id,
        name: "Video",
        component: lr,
        config: {
          blockId: t.id,
          video: {
            url: ((g = t.content) == null ? void 0 : g.embeddableUrl) || "",
            isAutoplay: !1,
            title: (m = (C = t.content) == null ? void 0 : C.title) != null ? m : ""
          }
        },
        properties: T(t),
        hasForm: !0
      };
    case qi:
      return {
        id: t.id,
        name: "Accordion",
        component: Tr,
        config: {
          blockId: t.id,
          accordion: {
            theme: t.properties.theme,
            icon_style: t.properties.iconStyle,
            allow_multiple_open_panels: t.properties.allowMultipleOpenPanels,
            items: t.nodes[0].nodes.map((p) => r({}, P(p, i)))
          }
        },
        properties: T(t),
        hasForm: !0
      };
    case Gi:
      return {
        id: t.id,
        text: t.properties.text,
        panelExpanded: t.properties.panelExpanded,
        content: t.nodes[0].nodes.map((p) => r({}, P(p, i))),
        properties: T(t)
      };
    case $i:
      return {
        id: t.id,
        name: "Space",
        config: {
          blockId: t.id,
          spacer: {
            height: t.properties.height,
            backgroundColor: t.properties.backgroundColor || "#ffffff",
            isTransparent: t.properties.isTransparent || !1
          }
        },
        properties: T(t),
        hasForm: !0,
        component: mr
      };
    case Wi:
      return {
        id: t.id,
        name: "Separator",
        component: hr,
        config: {
          blockId: t.id,
          divider: {
            thickness: t.properties.thickness,
            style: "solid",
            width: t.properties.width,
            color: { hex: t.properties.color }
          }
        },
        properties: T(t),
        hasForm: !0
      };
    case zi: {
      const { heading: p, text: e, image: l } = t.content, b = {
        blockId: t.id,
        card: {
          headline: p.content.html,
          content: e.content.html,
          image: {
            url: (l == null ? void 0 : l.assetUrl) || ((f = l == null ? void 0 : l.content) == null ? void 0 : f.assetUrl) || ((_ = i[l.content.assetId]) == null ? void 0 : _.url) || "",
            alt_text: l.content.altText,
            asset_id: l.content.assetId,
            decorative_image: l.properties.isDecorative,
            focalPointPosition: l.properties.focalPointPosition,
            cropped_height: l.properties.naturalHeight,
            // NEW
            cropped_width: l.properties.naturalWidth,
            // NEW
            sizes: {}
            // Sizes are not included in the new version
          },
          design: t.properties.design,
          hasImage: t.properties.showImage,
          hasHeadline: t.properties.showHeadline,
          imageRight: t.properties.imagePosition === "right",
          wrapText: t.properties.wrapText
        }
      };
      return {
        id: t.id,
        name: "Card",
        component: br,
        config: b,
        properties: T(t),
        hasForm: !0
      };
    }
    case L:
      return {
        id: t.id,
        name: "Table",
        component: Cr,
        config: {
          table: {
            content: t.content.html,
            theme: t.properties.theme,
            alternatingColors: t.properties.alternatingColors
          },
          blockId: t.id
        },
        properties: T(t),
        hasForm: !0
      };
    case Bi:
      return {
        id: t.id,
        name: "Quote",
        component: yr,
        config: {
          blockId: t.id,
          quote: {
            content: t.content.quote,
            author: t.content.author,
            source: t.content.source,
            design: t.properties.design,
            color: {
              hex: t.properties.color
            }
          }
        },
        properties: T(t),
        hasForm: !0
      };
    case Mi: {
      const p = t.content.formId == null ? {} : {
        blockId: t.id,
        form: {
          form_id: t.content.formId,
          show_one_question_at_time: t.properties.showOneQuestionAtATime
        }
      };
      return {
        id: t.id,
        name: "Form",
        component: Ir,
        config: p,
        properties: T(t),
        hasForm: !0
      };
    }
    case Hi: {
      const p = {
        button: {
          // Properties
          size: t.properties.size,
          type: t.properties.type,
          theme: t.properties.theme,
          alignment: t.properties.alignment,
          pill: t.properties.pillShape,
          style: t.properties.style,
          has_icons: t.properties.hasIcons,
          // Content
          buttons: (h = (o = t.content) == null ? void 0 : o.buttons) == null ? void 0 : h.map((e) => s(r(r({
            title: e.title,
            link: e.link,
            open_link_in_new_tab: e.newTab
          }, e.icon ? { icon: e.icon } : {}), e.iconId ? { icon_id: e.iconId } : {}), {
            mailto: e.mailto
          }))
        },
        blockId: t.id
      };
      return {
        id: t.id,
        name: "Button",
        config: p,
        properties: T(t),
        hasForm: !0,
        component: Nr
      };
    }
    case Fi:
      return {
        id: t.id,
        name: "List",
        config: {
          list: {
            items: [...t.content.items],
            design: t.properties.design,
            format: t.properties.format
          },
          blockId: t.id
        },
        properties: T(t),
        hasForm: !0,
        component: Or
      };
    case Ri:
      return {
        id: t.id,
        name: "Navigation",
        config: {
          selectedPageId: t.content.selectedPageId,
          selectedChildrenIds: t.content.selectedChildrenIds,
          design: t.properties.design,
          color: t.properties.color,
          isSynced: t.properties.isSiteMenuSynced
        },
        hasForm: !0,
        component: Er
      };
    case Ui:
      return {
        id: t.id,
        name: E,
        config: {
          id: t.id,
          name: E,
          type: E,
          sharedContentId: `${t.sharedContentId}`,
          properties: t.properties
        },
        hasForm: !0,
        component: E
      };
    default:
      return console.error("Unhandled node type: ", t), t;
  }
}, y = (t, i) => ({
  id: t.id,
  properties: wr(t),
  config: vr(t, i),
  hasForm: !1
}), T = (t) => {
  var i, a;
  return {
    anchorTag: ((i = t.properties) == null ? void 0 : i.anchorTag) || "",
    customClasses: ((a = t.properties) == null ? void 0 : a.customClasses) || []
  };
}, vr = (t, i) => t.nodes ? t.nodes.map((n) => {
  var g;
  return ((g = n.nodes) == null ? void 0 : g.map((C) => P(C, i))) || n;
}) : t, wr = (t) => {
  var i, a, n;
  return s(r({}, t.properties), {
    borderRadius: s(r({}, t.properties.borderRadius), {
      value: Number((i = t.properties.borderRadius) == null ? void 0 : i.value) || 0
    }),
    padding: s(r({}, t.properties.padding), {
      value: Number((a = t.properties.padding) == null ? void 0 : a.value) || 0
    }),
    margin: s(r({}, t.properties.margin), {
      value: Number((n = t.properties.margin) == null ? void 0 : n.value) || 0
    }),
    backgroundColor: s(r({}, t.properties.backgroundColor), {
      value: t.properties.backgroundColor.value || ""
    }),
    backgroundImage: s(r({}, t.properties.backgroundImage), {
      image: t.properties.backgroundImage.image || null
    })
  });
}, xr = (t) => {
  const { header: i, matrix: a, orientation: n, textAlign: g, bold: C } = r({ header: [] }, t), m = (_) => {
    const o = _ == null ? "<p></p>" : _;
    if (g !== "center")
      return o;
    const h = /<p>/, p = /<p style=".*">/;
    return o.match(h) ? o.replace("<p>", `<p style="text-align: ${g};">`) : o.match(p) ? o.match(p)[0].includes("text-align:") ? o : o.replace('<p style="', `<p style="text-align: ${g};`) : o;
  }, f = ["<table>"];
  if (n === "horizontal")
    if (C) {
      const _ = a.map((o, h) => ["<tr>", `<th scope="row">${m(i[h].value)}</th>`, ...o.map((p) => `<td>${m(p.value)}</td>`), "</tr>"].join(""));
      f.push(..._);
    } else {
      const _ = a.map((o, h) => ["<tr>", `<td>${m(i[h].value)}</td>`, ...o.map((p) => `<td>${m(p.value)}</td>`), "</tr>"].join(""));
      f.push(..._);
    }
  else {
    if (i.length > 0)
      if (C) {
        const o = i.map((h) => `<th scope="col">${m(h.value)}</th>`);
        f.push("<tr>", ...o, "</tr>");
      } else {
        const o = i.map((h) => `<td>${m(h.value)}</td>`);
        f.push("<tr>", ...o, "</tr>");
      }
    const _ = a.map((o) => ["<tr>", ...o.map((h) => `<td>${m(h.value)}</td>`), "</tr>"].join(""));
    f.push(..._);
  }
  return f.push("</table>"), f.join("");
};
let S;
const zr = (t) => {
  var C, m;
  S = {};
  let i = [];
  ((C = t[0]) == null ? void 0 : C.id) === "root" ? i = t[0].config.flat() : i = t;
  const a = i.map((f) => R(f)), n = ((m = t[0]) == null ? void 0 : m.properties) || {
    backgroundColor: {
      toggle: !1,
      value: ""
    },
    backgroundImage: {
      toggle: !1,
      image: null
    }
  };
  return {
    structure: {
      id: "root",
      name: "Root",
      type: k,
      properties: n,
      nodes: a
    },
    assets: S
  };
}, Ur = ({ component: t }) => {
  const i = t === U;
  return {
    borderRadius: {
      value: 0
    },
    backgroundColor: {
      toggle: !1,
      value: ""
    },
    backgroundImage: {
      toggle: !1,
      image: null
    },
    margin: {
      linked: !i,
      value: 10,
      top: 10,
      bottom: 10,
      left: i ? 0 : 10,
      right: i ? 0 : 10
    },
    padding: {
      linked: !0,
      value: 0,
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    },
    customClasses: [],
    anchorTag: ""
  };
}, R = (t) => {
  var i, a, n, g, C, m, f, _, o, h, p, e, l, b, F, H, M, B, z, W, $, G, q, Y, V, Q, j, X, K, J, Z, d, tt, it, rt, et, st, at, ct, ot, pt, nt, lt, gt, ut, mt, ft, _t, ht, Tt, Ct, Nt, bt, yt, It, Ot, Et, wt, kt, At, Pt, St, Dt, Lt, vt, xt, Ut, Rt, Ft, Ht, Mt, Bt, zt, Wt, $t, Gt, qt, Yt, Vt, Qt, jt, Xt, Kt, Jt, Zt, dt, ti, ii, ri, ei, si, ai, ci, oi, pi, ni, li, gi, ui, mi, fi, _i, hi, Ti, Ci, Ni, bi, yi, Ii, Oi, Ei, wi, ki, Ai, Pi, Si, Di;
  switch (t == null ? void 0 : t.component) {
    case rr:
      return s(r({}, I(t)), {
        name: "One Column",
        type: ir
      });
    case er:
      return s(r({}, I(t)), {
        name: "Two Columns",
        type: tr
      });
    case sr:
      return s(r({}, I(t)), {
        name: "Three Columns",
        type: di
      });
    case ar:
      return s(r({}, I(t)), {
        name: "Four Columns",
        type: Zi
      });
    case cr:
      return s(r({}, I(t)), {
        name: "Left Sidebar",
        type: Ji
      });
    case or:
      return s(r({}, I(t)), {
        name: "Right Sidebar",
        type: Ki
      });
    case U:
      return s(r({}, I(t)), {
        name: "Full Width",
        type: Xi
      });
    case pr:
      return {
        id: t.id,
        name: "Heading",
        type: x,
        content: {
          html: t.config.content
        },
        properties: u(t)
      };
    case nr:
      return {
        id: t.id,
        name: "Text",
        type: v,
        content: {
          html: t.config.content
        },
        properties: u(t)
      };
    case mr:
      return {
        id: t.id,
        name: "Spacer",
        type: $i,
        properties: s(r({}, u(t)), {
          height: t.config.spacer.height,
          backgroundColor: t.config.spacer.backgroundColor || "#ffffff",
          isTransparent: t.config.spacer.isTransparent || !1
        })
      };
    case hr:
      return {
        id: t.id,
        name: "Separator",
        type: Wi,
        properties: s(r(r({}, u(t)), t.config.divider), {
          color: (i = t.config.divider.color) == null ? void 0 : i.hex,
          style: ((a = t.config.divider) == null ? void 0 : a.style) || "solid"
        })
      };
    case gr:
      return {
        id: t.id,
        name: "Code",
        type: Vi,
        content: {
          html: t.config.embed
        },
        properties: s(r({}, u(t)), {
          hasScriptTag: t.config.hasScriptTag
        })
      };
    case lr:
      return {
        id: t.id,
        name: "Video",
        type: Yi,
        content: {
          rawUrl: "",
          embeddableUrl: ((n = t.config.video) == null ? void 0 : n.url) || "",
          isResized: !1,
          title: ((g = t.config.video) == null ? void 0 : g.title) || "",
          videoAlignment: "center",
          width: "100%"
        },
        properties: u(t)
      };
    case yr:
      return {
        id: t.id,
        name: "Quote",
        type: Bi,
        content: {
          quote: t.config.quote.content,
          author: t.config.quote.author,
          source: t.config.quote.source
        },
        properties: s(r({}, u(t)), {
          design: t.config.quote.design,
          color: t.config.quote.color.hex
        })
      };
    case fr: {
      w((m = (C = t == null ? void 0 : t.config) == null ? void 0 : C.image) == null ? void 0 : m.asset_id, (_ = (f = t == null ? void 0 : t.config) == null ? void 0 : f.image) == null ? void 0 : _.url);
      const N = ((h = (o = t == null ? void 0 : t.config) == null ? void 0 : o.image) == null ? void 0 : h.show_caption) === null || ((e = (p = t == null ? void 0 : t.config) == null ? void 0 : p.image) == null ? void 0 : e.show_caption) === void 0 ? !0 : !!((b = (l = t == null ? void 0 : t.config) == null ? void 0 : l.image) != null && b.show_caption);
      return {
        id: t.id,
        name: "Image",
        type: O,
        assetUrl: ((H = (F = t == null ? void 0 : t.config) == null ? void 0 : F.image) == null ? void 0 : H.url) || "",
        content: {
          assetUrl: ((B = (M = t == null ? void 0 : t.config) == null ? void 0 : M.image) == null ? void 0 : B.url) || "",
          assetId: ((W = (z = t == null ? void 0 : t.config) == null ? void 0 : z.image) == null ? void 0 : W.asset_id) || "",
          altText: ((G = ($ = t == null ? void 0 : t.config) == null ? void 0 : $.image) == null ? void 0 : G.alt_text) || "",
          caption: ((Y = (q = t == null ? void 0 : t.config) == null ? void 0 : q.image) == null ? void 0 : Y.caption) || "",
          link: ((Q = (V = t == null ? void 0 : t.config) == null ? void 0 : V.image) == null ? void 0 : Q.link_url) || ""
        },
        properties: s(r({}, u(t)), {
          actionOnClick: ((X = (j = t == null ? void 0 : t.config) == null ? void 0 : j.image) == null ? void 0 : X.action_on_click) || "no-action",
          newTab: ((J = (K = t == null ? void 0 : t.config) == null ? void 0 : K.image) == null ? void 0 : J.open_link_in_new_tab) || !1,
          imageAlignment: ((d = (Z = t == null ? void 0 : t.config) == null ? void 0 : Z.image) == null ? void 0 : d.image_alignment) || "",
          captionAlignment: ((it = (tt = t == null ? void 0 : t.config) == null ? void 0 : tt.image) == null ? void 0 : it.caption_alignment) || "",
          columnPercentage: ((et = (rt = t == null ? void 0 : t.config) == null ? void 0 : rt.image) == null ? void 0 : et.set_ratio) * 100 || 0,
          isResized: !!((at = (st = t == null ? void 0 : t.config) == null ? void 0 : st.image) != null && at.is_resized),
          resizeMode: ((ot = (ct = t == null ? void 0 : t.config) == null ? void 0 : ct.image) == null ? void 0 : ot.display) || "actual-size",
          showCaption: N,
          isDecorative: ((nt = (pt = t == null ? void 0 : t.config) == null ? void 0 : pt.image) == null ? void 0 : nt.decorative_image) || !1,
          naturalWidth: ((gt = (lt = t == null ? void 0 : t.config) == null ? void 0 : lt.image) == null ? void 0 : gt.cropped_width) || null,
          naturalHeight: ((mt = (ut = t == null ? void 0 : t.config) == null ? void 0 : ut.image) == null ? void 0 : mt.cropped_height) || null,
          preferredWidth: ((_t = (ft = t == null ? void 0 : t.config) == null ? void 0 : ft.image) == null ? void 0 : _t.preferred_width) || 0,
          preferredHeight: ((Tt = (ht = t == null ? void 0 : t.config) == null ? void 0 : ht.image) == null ? void 0 : Tt.preferred_height) || 0
        })
      };
    }
    case _r: {
      const N = t.config.gallery.images.map((c) => (w(c.asset_id, c.url), {
        name: "Image",
        type: O,
        assetUrl: c.url,
        content: {
          assetUrl: c.url,
          assetId: c.asset_id,
          altText: c.alt_text,
          caption: c.caption || ""
          // New
        },
        properties: s(r({}, u(t)), {
          isDecorative: c.decorative_image,
          naturalWidth: c.cropped_width,
          naturalHeight: c.cropped_height,
          focalPointPosition: c.focalPointPosition || {
            // New
            x: 50,
            y: 50
          }
        })
      }));
      return {
        id: t.id,
        name: "Gallery",
        type: ji,
        content: {
          images: N
        },
        properties: s(r({}, u(t)), {
          columnsCount: t.config.gallery.columns,
          isLightbox: t.config.gallery.hasLightbox,
          showCaptions: t.config.gallery.showCaptions || !1,
          // New
          captionsAlignment: t.config.gallery.captionsAlignment || "center"
          // New
        })
      };
    }
    case ur: {
      const N = t.config.slider.images.map((c) => (w(c.asset_id, c.url), {
        name: "Image",
        type: O,
        assetUrl: c.url,
        content: {
          assetUrl: c.url,
          assetId: c.asset_id,
          altText: c.alt_text,
          caption: c.caption || "",
          // New
          link: c.link_url || ""
        },
        properties: s(r({}, u(t)), {
          actionOnClick: c.action_on_click,
          newTab: c.open_link_in_new_tab,
          isDecorative: c.decorative_image,
          naturalWidth: c.cropped_width || 0,
          // New
          naturalHeight: c.cropped_height || 0,
          // New
          focalPointPosition: c.focalPointPosition || {
            // New
            x: 50,
            y: 50
          }
        })
      }));
      return {
        id: t.id,
        name: "Slider",
        type: Qi,
        content: {
          images: N
        },
        properties: s(r({}, u(t)), {
          showDots: t.config.slider.has_dots,
          dotsPosition: t.config.slider.dot_position === "bottom" ? "below" : t.config.slider.dot_position,
          showArrows: t.config.slider.has_arrows,
          arrowsPosition: t.config.slider.arrow_position,
          isAutoplay: t.config.slider.is_autoplay,
          transitionSpeed: t.config.slider.transition
        })
      };
    }
    case Nr:
      return {
        id: t.id,
        name: "Button",
        type: Hi,
        content: {
          buttons: ((bt = (Nt = (Ct = t.config) == null ? void 0 : Ct.button) == null ? void 0 : Nt.buttons) == null ? void 0 : bt.map((N) => ({
            title: N.title,
            link: N.link,
            newTab: N.open_link_in_new_tab || !1,
            mailto: N.mailto || !1,
            icon: N.icon || null,
            iconId: N.icon_id || null
          }))) || []
        },
        properties: s(r({}, u(t)), {
          type: ((It = (yt = t.config) == null ? void 0 : yt.button) == null ? void 0 : It.type) || "regular",
          theme: ((Et = (Ot = t.config) == null ? void 0 : Ot.button) == null ? void 0 : Et.theme) || "light",
          size: ((kt = (wt = t.config) == null ? void 0 : wt.button) == null ? void 0 : kt.size) || "regular",
          pillShape: !!((Pt = (At = t.config) == null ? void 0 : At.button) != null && Pt.pill),
          alignment: ((Dt = (St = t.config) == null ? void 0 : St.button) == null ? void 0 : Dt.alignment) || "left",
          style: ((vt = (Lt = t.config) == null ? void 0 : Lt.button) == null ? void 0 : vt.style) || "1",
          hasIcons: !!((Ut = (xt = t.config) == null ? void 0 : xt.button) != null && Ut.has_icons)
        })
      };
    case br:
      return w((Ht = (Ft = (Rt = t == null ? void 0 : t.config) == null ? void 0 : Rt.card) == null ? void 0 : Ft.image) == null ? void 0 : Ht.asset_id, (zt = (Bt = (Mt = t == null ? void 0 : t.config) == null ? void 0 : Mt.card) == null ? void 0 : Bt.image) == null ? void 0 : zt.url), {
        id: t.id,
        name: "Card",
        type: zi,
        content: {
          heading: xi({
            id: `cardTitle_${t.id}`,
            type: x,
            content: { html: ($t = (Wt = t == null ? void 0 : t.config) == null ? void 0 : Wt.card) == null ? void 0 : $t.headline }
          }),
          text: xi({
            id: `cardContent_${t.id}`,
            type: v,
            content: { html: (qt = (Gt = t == null ? void 0 : t.config) == null ? void 0 : Gt.card) == null ? void 0 : qt.content }
          }),
          image: {
            name: "Image",
            type: O,
            assetUrl: ((Qt = (Vt = (Yt = t == null ? void 0 : t.config) == null ? void 0 : Yt.card) == null ? void 0 : Vt.image) == null ? void 0 : Qt.url) || "",
            content: {
              assetUrl: ((Kt = (Xt = (jt = t == null ? void 0 : t.config) == null ? void 0 : jt.card) == null ? void 0 : Xt.image) == null ? void 0 : Kt.url) || "",
              assetId: ((dt = (Zt = (Jt = t == null ? void 0 : t.config) == null ? void 0 : Jt.card) == null ? void 0 : Zt.image) == null ? void 0 : dt.asset_id) || "",
              altText: ((ri = (ii = (ti = t == null ? void 0 : t.config) == null ? void 0 : ti.card) == null ? void 0 : ii.image) == null ? void 0 : ri.alt_text) || ""
            },
            properties: {
              isDecorative: ((ai = (si = (ei = t == null ? void 0 : t.config) == null ? void 0 : ei.card) == null ? void 0 : si.image) == null ? void 0 : ai.decorative_image) || !1,
              naturalWidth: ((pi = (oi = (ci = t == null ? void 0 : t.config) == null ? void 0 : ci.card) == null ? void 0 : oi.image) == null ? void 0 : pi.cropped_width) || 0,
              // New
              naturalHeight: ((gi = (li = (ni = t == null ? void 0 : t.config) == null ? void 0 : ni.card) == null ? void 0 : li.image) == null ? void 0 : gi.cropped_height) || 0,
              // New
              focalPointPosition: ((fi = (mi = (ui = t == null ? void 0 : t.config) == null ? void 0 : ui.card) == null ? void 0 : mi.image) == null ? void 0 : fi.focalPointPosition) || {
                // New
                x: 50,
                y: 50
              }
            }
          }
        },
        properties: s(r({}, u(t)), {
          design: ((hi = (_i = t == null ? void 0 : t.config) == null ? void 0 : _i.card) == null ? void 0 : hi.design) || "box-shadow",
          showImage: ((Ci = (Ti = t == null ? void 0 : t.config) == null ? void 0 : Ti.card) == null ? void 0 : Ci.hasImage) || !1,
          showHeadline: ((bi = (Ni = t == null ? void 0 : t.config) == null ? void 0 : Ni.card) == null ? void 0 : bi.hasHeadline) || !1,
          imagePosition: (Ii = (yi = t == null ? void 0 : t.config) == null ? void 0 : yi.card) != null && Ii.imageRight ? "right" : "left",
          wrapText: ((Ei = (Oi = t == null ? void 0 : t.config) == null ? void 0 : Oi.card) == null ? void 0 : Ei.wrapText) || !1,
          textCursor: ((ki = (wi = t == null ? void 0 : t.config) == null ? void 0 : wi.card) == null ? void 0 : ki.textCursor) || 0,
          headlineCursor: ((Pi = (Ai = t == null ? void 0 : t.config) == null ? void 0 : Ai.card) == null ? void 0 : Pi.headlineCursor) || 0
        })
      };
    case Ir:
      return {
        id: t.id,
        name: "Form",
        type: Mi,
        content: {
          formId: ((Si = t.config.form) == null ? void 0 : Si.form_id) || null
        },
        properties: s(r({}, u(t)), {
          showOneQuestionAtATime: ((Di = t.config.form) == null ? void 0 : Di.show_one_question_at_time) || !1
        })
      };
    case Lr:
      return {
        id: t.id,
        name: "Table",
        type: L,
        content: {
          html: xr(t.config.table)
        },
        properties: s(r({}, u(t)), {
          theme: "default",
          alternatingColors: !1
        })
      };
    case Cr:
      return {
        id: t.id,
        name: "Table",
        type: L,
        content: {
          html: t.config.table.content
        },
        properties: s(r({}, u(t)), {
          theme: t.config.table.theme,
          alternatingColors: t.config.table.alternatingColors
        })
      };
    case Tr: {
      const N = t.config.accordion.icon_style === "minus" ? "plus" : t.config.accordion.icon_style, c = {
        id: t.id,
        name: "Accordion",
        type: qi,
        properties: s(r({}, u(t)), {
          theme: t.config.accordion.theme,
          iconStyle: N,
          allowMultipleOpenPanels: t.config.accordion.allow_multiple_open_panels
        }),
        nodes: [
          s(r({}, A({ type: k })), {
            nodes: t.config.accordion.items.map((D) => Rr(D))
          })
        ]
      };
      return c.nodes[0].nodes.map((D) => D.parentAccordionId = c.id), c;
    }
    case Or:
      return {
        id: t.id,
        name: "List",
        type: Fi,
        content: {
          items: [...t.config.list.items]
        },
        properties: s(r({}, u(t)), {
          design: t.config.list.design,
          format: t.config.list.format
        })
      };
    case Er:
      return {
        id: t.id,
        name: "Navigation",
        type: Ri,
        content: {
          selectedPageId: t.config.selectedPageId,
          selectedChildrenIds: t.config.selectedChildrenIds
        },
        properties: {
          design: t.config.design,
          color: t.config.color,
          isSiteMenuSynced: t.config.isSynced
        }
      };
    case E:
      return {
        id: t.id,
        name: "Shared content",
        type: Ui,
        sharedContentId: t.config.sharedContentId,
        properties: t.config.properties,
        nodes: [
          r({}, A({ type: k }))
        ]
      };
    default:
      return console.error("Unhandled node type: ", t), t;
  }
}, Rr = (t) => ({
  id: t.id,
  name: "Accordion Panel",
  type: Gi,
  properties: s(r({}, u(t)), {
    text: t.text,
    panelExpanded: t.panelExpanded
  }),
  nodes: [
    s(r({}, A({ type: k })), {
      nodes: t.content.map((i) => R(i))
    })
  ]
}), w = (t, i) => {
  S = s(r({}, S), {
    [t]: {
      url: i
    }
  });
}, I = (t) => {
  var a, n, g, C, m, f, _, o;
  (g = (n = (a = t.properties) == null ? void 0 : a.backgroundImage) == null ? void 0 : n.image) != null && g.content && w(
    (f = (m = (C = t.properties.backgroundImage) == null ? void 0 : C.image) == null ? void 0 : m.content) == null ? void 0 : f.assetId,
    (o = (_ = t.properties.backgroundImage) == null ? void 0 : _.image) == null ? void 0 : o.assetUrl
  );
  const i = r({
    customClasses: [],
    anchorTag: ""
  }, t.properties || Ur(t));
  return {
    id: t.id,
    properties: i,
    nodes: Fr(t)
  };
}, u = (t) => {
  var i, a;
  return {
    anchorTag: ((i = t.properties) == null ? void 0 : i.anchorTag) || "",
    customClasses: ((a = t.properties) == null ? void 0 : a.customClasses) || []
  };
}, Fr = (t) => t.config ? t.config.map((a) => {
  const n = a.map((g) => R(g));
  return s(r({}, A({ type: k })), {
    nodes: n
  });
}).flat() : [];
export {
  zr as convertLegacyPageConfigToPageBuilderConfig,
  Br as convertPageBuilderConfigToLegacyPageConfig,
  xr as convertTableToV2
};
